// extracted by mini-css-extract-plugin
export var activityCarousel = "styles-module__activityCarousel___TmVUV";
export var container = "styles-module__container___rCzvw";
export var header = "styles-module__header___eADxD";
export var link = "styles-module__link___rvpPZ";
export var signUp = "styles-module__signUp___GNGXC";
export var subText = "styles-module__subText___kBOLc";